import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "#api";
import { useDebounce } from "#utils";
import Filters from "./filters";
import AnimalTable from "./animal_table";
import AnimalListItem from "./animal_list_item";
import { Pagination } from "#common";

function AnimalList() {
  const [keyword, setKeyword] = useState("");
  const [pageQuery, setPageQuery] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const query = useQuery({
    queryKey: ["animals", debouncedKeyword, pageQuery],
    queryFn: async () => {
      var query = debouncedKeyword || pageQuery ? "?" : "";
      if (debouncedKeyword) {
        query += `keyword=${debouncedKeyword}`;
        if (pageQuery) {
          query += "&";
        }
      }
      if (pageQuery) {
        query += pageQuery;
      }
      const data = await get(`/animal${query}`);
      return data;
    },
  });
  const handleKeywordUpdate = (e) => {
    setPageQuery("");
    setKeyword(e);
  };
  return (
    <div>
      <Filters keyword={keyword} setKeyword={handleKeywordUpdate} />
      <div className="flex flex-col gap-2 py-2 mx-2">
        {query.data?.items.map((animal) => (
          <AnimalListItem
            key={`animal-list-id-${animal.animalId}`}
            animal={animal}
          />
        ))}
      </div>
      <Pagination {...query.data} setPageQuery={setPageQuery} />
    </div>
  );
}
export default AnimalList;
